import theme from '@styles/theme';
export default {
  noResultsFoundContainer: {
    display: 'flex',
    width: '100%',
    height: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    padding: '12px 0 28px 0',
    p: {
      fontSize: theme.fontSizes.bigText
    }
  }
};